export default "__VITE_ASSET__DxqTQ0Gi__"